import { DeviceSummary, DeviceType } from '../models/device';
import { deviceClient } from './api-grpc';

const PAGE_SIZE = 100;

export const deviceApi = {
  /** Every device of one type, ordered by the API (newest first). Device counts are small, so the list is filtered
   * on the client like the design expects. */
  async listAllByType(type: DeviceType): Promise<DeviceSummary[]> {
    const devices: DeviceSummary[] = [];
    for (let pageIndex = 1; ; pageIndex++) {
      const response = await deviceClient.getDeviceListByPage({ pagination: { pageIndex, pageSize: PAGE_SIZE }, type });
      devices.push(...response.devices.map(({ uuid, name, type }) => ({ uuid, name, type })));
      const total = response.metadata?.totalCount ?? 0;
      if (response.devices.length < PAGE_SIZE || devices.length >= total) break;
    }
    return devices;
  },

  async countByType(type: DeviceType): Promise<number> {
    const response = await deviceClient.getDeviceListByPage({ pagination: { pageIndex: 1, pageSize: 1 }, type });
    return response.metadata?.totalCount ?? 0;
  },

  async getByUuid(uuid: string): Promise<DeviceSummary> {
    const response = await deviceClient.getDeviceByUuid({ uuid });
    if (!response.device) throw new Error('Device not found');
    const { name, type } = response.device;
    return { uuid: response.device.uuid, name, type };
  },
};
